import { Outlet } from "react-router-dom";

import style from "./style.module.scss";
import SimpleHeader from "../simple-header";

function AppLayout() {
  return (
    <div className={style.layout}>
      <SimpleHeader />
      <Outlet />
    </div>
  );
}

export default AppLayout;
